// frontend/src/components/RepresentativePopupCard.jsx
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const RepresentativePopupCard = ({ open, onClose, rep }) => {
  if (!rep) return null;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center px-4"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white w-full max-w-md rounded-xl shadow-xl p-6 relative"
          >
            <button
              onClick={onClose}
              className="absolute top-3 right-3 text-gray-500 hover:text-red-500"
            >
              <X size={20} />
            </button>

            <div className="text-center">
              <img
                src={rep.image_url || "/leader-default.png"}
                alt={rep.name}
                className="w-24 h-24 rounded-full mx-auto mb-3 object-cover"
              />
              <h2 className="text-xl font-bold text-gray-800 mb-1">{rep.name}</h2>
              <p className="text-sm text-gray-600">
                {rep.position} — {rep.constituency}
              </p>
              <p className="text-sm font-medium text-blue-700 mt-1">
                {typeof rep.party === "string" ? rep.party : JSON.stringify(rep.party)}
              </p>

              <div className="mt-4 text-left space-y-1 text-sm text-gray-600">
                <p><strong>District:</strong> {rep.district}</p>
                <p><strong>Terms Served:</strong> {rep.terms_served}</p>
                <p><strong>Status:</strong> {rep.membership_status}</p>
              </div>

              <button
                onClick={() =>
                  window.location.href = `/raise-issue?to=${rep.position.toLowerCase()}&name=${rep.name}`
                }
                className="mt-6 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded"
              >
                ✊ Raise Issue
              </button>

              {/* 📄 View Profile Button */}
              <Link
                to={`/candidate/${rep.name.toLowerCase().replace(/\s+/g, '-')}`}
                className="mt-3 inline-block text-blue-600 font-medium text-sm hover:underline"
              >
                📄 View Profile →
              </Link>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RepresentativePopupCard;
